<template>
    <div>
        <Row>
            <Col span="24">
            <div class="popalert" v-show="isShowTopMsg">
                    <Alert closable type="warning" show-icon>特别提示：请及时关注微信公众号“众智云擎税法检索”, 即时精准获取税法文件智能推送。戳我扫码并关注
                        <Poptip placement="right">
                            <Button type="text" style="box-shadow: none;background-color: transparent;color:green;position: relative;top:-1px;" size="small">众智云擎公众号</Button>
                            <div class="api" slot="content">
                                <img style="width:200px;height: 200px;" src="../../assets/images/zzyq_qrcode.jpg">
                            </div>
                        </Poptip>
                    </Alert>
                </div>
            </Col>
        </Row>
        <!-- Tabs中包含table时,不嵌套row,col会引起table在渲染时缓慢滚动宽度 -->
        <p class="main_title">文件提醒</p>
        <Row>
            <Col span="24">
            <Tabs :animated="false" size="small" name="1">
                <TabPane label="最新文件" tab="1">
                    <MyPushTable ref="mylastpushlist" @changepage="cloudChangePage"></MyPushTable>
                </TabPane>
                <TabPane label="效力变动" tab="1">
                    <MyTable ref="myuploadlibrary" @changepage="cloudChangePage"></MyTable>
                </TabPane>
                <TabPane :label="labletxt" tab="1">
                    <div v-if="treeType===2" class="childtabs">
                        <Tabs type="card" :animated="false" name="2">
                            <TabPane label="通用规定" tab="2" name='name1'>
                                <MyPushTable ref="mycommonpushlist" @changepage="cloudChangePage" @setAllFilesIsRead="setAllReadReload"></MyPushTable>
                            </TabPane>
                            <TabPane label="专属规定" tab="2" name='name2'>
                                <MyPushTable ref="myspecialpushlist" @changepage="cloudChangePage" @setAllFilesIsRead="setAllReadReload"></MyPushTable>
                            </TabPane>
                        </Tabs>
                    </div>
                    <div v-else-if="treeType===1" class="childtabs">
                        <MyPushTable ref="mypreferentialitem" @changepage="cloudChangePage" @setAllFilesIsRead="setAllReadReload"></MyPushTable>
                    </div>
                    <div v-else-if="treeType===3">
                        <MyPushTable ref="mytax" @changepage="cloudChangePage" @setAllFilesIsRead="setAllReadReload"></MyPushTable>
                    </div>
                    <div v-else></div>
                </TabPane>
            </Tabs>
            </Col>
        </Row>
        <br />
        <!--    <Row>
      <Col span="24">
      <Collapse size="large" v-model="value2">
        <Panel name="1" size="large" class="cpllapse-panel-title">
          云端变动提醒-我的工作簿
          <div slot="content">
            <MyTable ref="myworkbook" @changepage="workBookChangePage"></MyTable>
          </div>
        </Panel>
      </Collapse>
      </Col>
    </Row> -->
    </div>
</template>
<script>
import AssistantTable from './notice_table.vue'
import AssistantTable2 from './notice_table2.vue'
import assistantData from '../../assets/json/assistantTable.json'
import assistantWorkTable from '../../assets/json/assistantWorkTable.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import store from '../../store'
import constJson from '../../api/common/constjson.js'
var constJ = new constJson()
export default {
    name: 'Assistant_Cloud_Notice',
    data() {
        return {
            switchRadio: '通用规定',
            isShowTopMsg: true,
            value1: "1",
            value2: "1",
            p_data: [], //assistantData,
            c_data: [], //assistantWorkTable,
            pageTotal: 10,
            PageIndex: 1,
            PageSize: 10,
            treeType: 0,
            fileheader: [{
                    "title": "文件名",
                    "key": "filename",
                    //"align": "left"
                    // "width": "1800px"
                },
                {
                    "title": "效力",
                    "key": "desc",
                    //"align": "left"
                    // "width": "400px"
                },
                {
                    "title": " ",
                    "key": "isread",
                    //"align": "left"
                    // "width": "100px"
                }
            ],
            workbookheader: [{
                    "title": "文件名",
                    "key": "filename",
                    //"align": "left"
                    // "width": "1800px"
                },
                {
                    "title": "效力变化描述",
                    "key": "desc",
                    //"align": "left"
                    // "width": "400px"
                },
                {
                    "title": " ",
                    "key": "isread",
                    //"align": "left"
                    // "width": "100px"
                }
            ],
            labletxt: (h) => {
                if (this.treeType === 3) {
                    return h('div', [
                        h('span', '优惠推送'),
                        h('span', {
                            style: {
                                color: 'red',
                            }
                        }, '（优惠税种）'),
                    ])
                }
                 if (this.treeType === 2) {
                    return h('div', [
                        h('span', '优惠推送'),
                        h('span', {
                            style: {
                                color: 'red',
                            }
                        }, '（优惠行业）'),
                    ])
                }
                if (this.treeType === 1) {
                    return h('div', [
                        h('span', '优惠推送'),
                        h('span', {
                            style: {
                                color: 'red',
                            }
                        }, '（优惠项目）'),
                    ])
                }
            }

        }
    },
    computed: {
        ...mapGetters(['sliderLength', 'getUserId', 'sta']),
    },
    components: {
        'MyTable': AssistantTable,
        'MyPushTable': AssistantTable2
    },
    created: function() {
        console.log('notice create==>')
        var type = this.$router.history.current.query.q_type
        //console.log(type)
        if (type === "cloudmsg") {
            //console.log("created.......")
            if (store.state.user.userId !== undefined && store.state.user.userId.length > 1) {
                //console.log("login in true.......")
                console.log("getMyPushSettings.......")
                this.getMyPushSettings()
                console.log("getUploadFilesChanges.......")
                this.getUploadFilesChanges(this.PageIndex)
                this.getLastPushList(1, this.$Tools.pushScene().NEW_DOC)
            } else {
                //重登录
            }
        }

        //启用地方版搜索引擎
        store.state.user.initData.currentVersion = '2'

    },
    provide() {
        return {
            setOneFileIsRead: this.setChangesFileIsRead,
            setAllFileIsRead: this.setAllChangesFileIsRead,
            setOneLastFile: this.setOneLastFileIsRead,
            setAllLastFile: this.setAllLastFilesIsRead,
            setOneTaxFile: this.setOneTaxFileIsRead,
            setAllTaxFiles: this.setAllTaxFilesIsRead,
        }
    },
    methods: {
        setAllReadReload() {
            this.getMyPushSettings()
            // this.getTaxBreakPushList(1, "1")
            // this.getTaxBreakPushList(1, "2")
        },
        reloadNoticeList() {
            if (store.state.user.userId !== undefined && store.state.user.userId.length > 1) {
                this.getUploadFilesChanges(this.PageIndex)
            }
        },

        setOneLastFileIsRead(value) {
            console.log('setOneLastFileIsRead=====>')
            let poData = {
                strdocid: value,
            }
            constJ.setOneOfLastPushFileIsRead(poData).then(res => {
                console.log(res)
            })
        },
        setAllLastFilesIsRead(value) {
            console.log('setAllLastFileIsRead=====>')
            let poData = {}
            constJ.setAllOfLastPushFilesIsRead(poData).then(res => {
                console.log(res)
            })
        },
        setOneTaxFileIsRead(value) {
            console.log('setOneTaxFileIsRead=====>')
            let poData = {
                strdocid: value,
            }
            constJ.setOneOfTaxFileIsRead(poData).then(res => {
                console.log(res)
            })
        },
        setAllTaxFilesIsRead(value) {
            console.log('setAllTaxFilesIsRead=====>')
            let poData = {}
            constJ.setAllOfTaxFilesIsRead(poData).then(res => {
                console.log(res)
            })
        },

        setChangesFileIsRead(value) {
            console.log('setChangesFileIsRead=====>')
            let poData = {
                strdocids: value,
            }
            constJ.reqSetFileChangesIsRead(poData).then(res => {
                console.log(res)
            })
        },
        setAllChangesFileIsRead(value) {
            console.log('setAllChangesFileIsRead=====>')
            constJ.reqSetAllFileChangesIsRead().then(res => {
                console.log(res)
                this.reloadNoticeList()
            })
        },
        //treetype=1 项目，2=行业 ，3=税种
        getMyPushSettings() {
            let args = {}
            constJ.getUserSetting(args).then(res => {
                console.log(res)
                if (res.item) {
                    this.treeType = res.item.treetype
                    if (this.treeType === 1) {
                        console.log('load puslist tax_item')
                        this.getTaxBreakPushList(1, this.$Tools.queryType().TAX_ITEM, this.$Tools.pushScene().TAX_ITEM)
                    } else if (this.treeType === 2) {
                        this.getTaxBreakPushList(1, this.$Tools.queryType().COMMON, this.$Tools.pushScene().COMMON)
                        this.getTaxBreakPushList(1, this.$Tools.queryType().SPECIAL, this.$Tools.pushScene().SPECIAL)
                    } else if (this.treeType === 3) {
                        console.log('load puslist tax_categories')
                        this.getTaxBreakPushList(1, this.$Tools.queryType().TAX_CATEGORIES, this.$Tools.pushScene().TAX_CATEGORIES)
                    } else {
                        //默认
                        console.log('默认行业==>')
                        this.getTaxBreakPushList(1, this.$Tools.queryType().COMMON, this.$Tools.pushScene().COMMON)
                        this.getTaxBreakPushList(1, this.$Tools.queryType().SPECIAL, this.$Tools.pushScene().SPECIAL)
                    }
                }

            })
        },
        getLastPushList(index, type) {
            let currentIndex = index
            let args = {
                page: index,
                line: this.PageSize,
            }
            console.log('getLastPushList===>')
            console.log(args)
            console.log(index,type)
            constJ.getPushListOfLast(args).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.fileheader,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.fileheader,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                tabname: "newfiles",
                            }
                        }
                    } else {

                    }
                } else {

                }
                this.$refs.mylastpushlist.show(obj, type)
            })
        },
        //querytype 1=通用规定，2=专属规定，3=项目，4=税种
        getTaxBreakPushList(index, querytype, scene) {
            let currentIndex = index
            let args = {
                querytype: querytype,
                page: index,
                line: this.PageSize,
            }
            console.log(args)
            constJ.getPushListOfTaxBreak(args).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.fileheader,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.fileheader,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                tabname: "newfiles",
                            }
                        }
                    } else {

                    }
                } else {

                }
                //console.log('scene===>'+scene)
                // console.log(this.$Tools.pushScene().TAX_CATEGORIES)
                // console.log(this.$Tools.queryType().TAX_CATEGORIES)
                // console.log(this.$Tools.getPermission().CODE_FUNC_SEARCH_ALL)
                // console.log(this.$Tools.getRenewType().PURCHASE)

                if (scene == this.$Tools.pushScene().COMMON) {
                    this.$refs.mycommonpushlist.show(obj, scene)
                } else if (scene == this.$Tools.pushScene().SPECIAL) {
                    this.$refs.myspecialpushlist.show(obj, scene)
                } else if (scene == this.$Tools.pushScene().TAX_ITEM) {
                    console.log('=====TAX_ITEM=====>')
                    console.log(obj)
                    this.$refs.mypreferentialitem.show(obj, scene)
                } else if (scene == this.$Tools.pushScene().TAX_CATEGORIES) {
                    console.log('================>')
                    console.log(obj)
                    this.$refs.mytax.show(obj, scene)
                }

            })
        },

        getUploadFilesChanges(index) {
            let currentIndex = index
            //console.log(currentIndex)
            constJ.reqUploadFilesChanges(this.PageSize, currentIndex).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.fileheader, //this.mockTableHeader(), //testData2.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.fileheader, //testData2.header,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        }
                    } else {

                    }
                } else {

                }
                this.$refs.myuploadlibrary.show(obj)
            }).catch(err => {
                console.log(err)
            })
        },

        getWorkBookChanges(index) {
            let currentIndex = index
            //console.log(currentIndex)
            constJ.reqWorkBookFileChanges(this.PageSize, currentIndex).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.workbookheader, //this.mockTableHeader(), //testData2.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.workbookheader, //testData2.header,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        }
                    } else {

                    }
                } else {

                }
                //this.$refs.myworkbook.show(obj)
            }).catch(err => {
                console.log(err)
            })
        },
        reload() {
            //console.log("reload...")
            // this.getUploadFilesChanges(this.PageIndex)
            // this.getWorkBookChanges(this.PageIndex)
            this.getMyPushSettings()
            this.getUploadFilesChanges(this.PageIndex)
            this.getLastPushList(1, this.$Tools.pushScene().NEW_DOC)


            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        cloudChangePage(index, type) {
            console.log('index=' + index, 'type=' + type)
            if (type === 1 || type === 2 || type === 3 || type === 4) {
                this.getTaxBreakPushList(index, type,type)
            } else if (type === 5) {
                this.getLastPushList(index, type)
            } else if (type === 6) {
                this.getUploadFilesChanges(index)
            }
            //this.getUploadFilesChanges(index)
        },
        workBookChangePage(index) {
            this.getWorkBookChanges(index)
        }

    },
    watch: {
        getUserId: function() {
            console.log(this.getUserId)
            if (this.getUserId === undefined) {
                this.$router.push({ path: '/main/searchengine/search' })
            } else {
                if (this.getUserId.length > 1) {
                    this.reload()
                }
            }

        }
    },

}
</script>
<style lang="less" scoped>

.popalert {
    background: #fff;
    width: 100%;
    padding-bottom: 10px;
    margin: 0 auto;
}

.popalert/deep/.ivu-icon {
    position: relative;
    top: 5px
}

.popalert/deep/.ivu-alert-close {
    top: 4px
}

.popalert/deep/.ivu-alert {
    margin-bottom: 0px;
}


.childtabs {
    /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
        height: 32px;
        padding-bottom: 5px;
        background: #2d8cf0;
        transform: translateZ(0);
        border-color: #dcdee2;
        // color: white;
    }

}

.main_title{
height: 20px;
font-size: 20px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #2D2F33;
margin-bottom: 30px;
padding-left: 10px;
}
</style>